"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FeIcon = _interopRequireDefault(require("./FeIcon"));

var _FeSelfContainedInput = _interopRequireDefault(require("./FeSelfContainedInput"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FeTableHeaderCell =
/*#__PURE__*/
function (_Component) {
  _inherits(FeTableHeaderCell, _Component);

  function FeTableHeaderCell(props) {
    var _this;

    _classCallCheck(this, FeTableHeaderCell);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeTableHeaderCell).call(this, props));
    _this.onSortIconClick = _this.onSortIconClick.bind(_assertThisInitialized(_this));
    _this.onFilterInputChange = _this.onFilterInputChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FeTableHeaderCell, [{
    key: "onSortIconClick",
    value: function onSortIconClick(event) {
      this.props.onSortChange && this.props.onSortChange({
        sortBy: this.props.name,
        sortOrder: this.props.sortBy === this.props.name && this.props.sortOrder === 'asc' ? 'desc' : 'asc'
      });
    }
  }, {
    key: "onFilterInputChange",
    value: function onFilterInputChange(event) {
      this.props.onFilterChange && this.props.onFilterChange({
        name: this.props.name,
        search: event.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      /** Minimum condition required to render*/

      /** Rendering of component */
      var className = (0, _classnames.default)('fe-table__header-cell', this.props.columnClass, this.props.className);
      var sortClassName = (0, _classnames.default)('fe-table__header-sort', {
        'fe-table__header-sort--asc': this.props.sortBy === this.props.name && this.props.sortOrder === 'asc',
        'fe-table__header-sort--desc': this.props.sortBy === this.props.name && this.props.sortOrder === 'desc'
      });
      return _react.default.createElement("div", {
        className: className,
        name: this.props.name,
        role: "columnheader"
      }, this.props.isDraggable && _react.default.createElement("div", {
        className: "fe-table__header-highlight",
        onMouseDown: this.props.onDragStart
      }), (this.props.label || this.props.name) && _react.default.createElement("div", {
        className: "fe-table__header-title"
      }, _react.default.createElement("span", {
        className: "fe-table__header-text",
        role: "columnheader"
      }, this.props.label || this.props.name), this.props.isSortable && _react.default.createElement("div", {
        className: sortClassName,
        onClick: this.onSortIconClick
      }, _react.default.createElement(_FeIcon.default, {
        family: "solid",
        icon: "sort-up"
      }), _react.default.createElement(_FeIcon.default, {
        family: "solid",
        icon: "sort-down"
      }))), this.props.withFilter && this.props.filterValue && _react.default.createElement("div", {
        className: "fe-table__header-filters"
      }, _react.default.createElement(_FeSelfContainedInput.default, {
        name: this.props.name,
        value: this.props.filterValue,
        placeholder: this.props.filterPlaceholder,
        onChange: this.onFilterInputChange
      })), this.props.withFilter && !this.props.filterValue && _react.default.createElement("div", {
        className: "fe-table__header-filters"
      }, _react.default.createElement(_FeSelfContainedInput.default, {
        name: this.props.name,
        placeholder: this.props.filterPlaceholder,
        onChange: this.onFilterInputChange
      })), this.props.children);
    }
  }]);

  return FeTableHeaderCell;
}(_react.Component);

FeTableHeaderCell.defaultProps = {
  name: null,
  label: null,
  filterPlaceholder: 'Search',
  columnClass: null,
  filterValue: null,
  sortBy: null,
  sortOrder: null,
  isDraggable: true,
  isSortable: true,
  withFilter: true,
  onSortChange: null,
  onFilterChange: null,
  onDragStart: null
};
FeTableHeaderCell.propTypes = {
  /** Provide name for table cell*/
  name: _propTypes.default.string,

  /** Provide label for table cell*/
  label: _propTypes.default.string,

  /** Provide placeholder for filter input*/
  filterPlaceholder: _propTypes.default.string,

  /** Provide class for column*/
  columnClass: _propTypes.default.string,

  /** Provide input value for filter*/
  filterValue: _propTypes.default.string,

  /** Provide name*/
  sortBy: _propTypes.default.string,

  /** Provide sort order */
  sortOrder: _propTypes.default.oneOf(['asc', 'desc']),

  /** Set true/false to make column draggable*/
  isDraggable: _propTypes.default.bool,

  /** Set true/false to make column sortable*/
  isSortable: _propTypes.default.bool,

  /** Set true/false to add filter input box*/
  withFilter: _propTypes.default.bool,

  /** Provide handler for sort change */
  onSortChange: _propTypes.default.func,

  /** Provide handler for filter change */
  onFilterChange: _propTypes.default.func,

  /** Provide handler for drag start */
  onDragStart: _propTypes.default.func
};
FeTableHeaderCell.displayName = 'FeTableHeaderCell';
var _default = FeTableHeaderCell;
exports.default = _default;